export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_TOKEN = 'auth/LOGIN_TOKEN'
export const RESTORE_USER = 'auth/RESTORE_USER'
export const UPDATE_AVATAR = 'auth/UPDATE_AVATAR'
export const SET_REGISTER_INFO = 'auth/SET_REGISTER_INFO'
export const CHANGE_LANGAUGE = 'auth/CHANGE_LANGAUGE'
export const UPDATE_PASSCODE = 'auth/UPDATE_PASSCODE'
export const UPDATE_LASTACCESSCOMPANY = 'auth/UPDATE_LASTACCESSCOMPANY'
export const PHOTO_USER = 'auth/PHOTO_USER'
export const USER_ACCESS_USER = 'auth/USER_ACCESS_USER'
export const BRANCH_SHOP_USER = 'auth/BRANCH_SHOP_USER'
